var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{staticClass:"avatar-sm"},[_c('img',{staticClass:"avatar-img rounded-circle",attrs:{"src":_vm.src}})]):_c('div',[_c('span',{staticClass:"avatar bg-primary-gradient text-white rounded-circle"},[_c('span',{staticClass:"initials"},[_vm._v("\n      "+_vm._s(_vm.initial)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }